export default "__VITE_ASSET__DYxT0oXz__"